import React from "react";

/**
 * リリーストラック情報（役割）
 */
export default function MusicAlbumInfoReleaseTrackRoleView({
  music,
} : {
  music: {
    remixer_name: string|null,
    remixer_name_en: string|null,
    music_production_and_engineering_roles: {
      id: number,
      role_text: string,
      name: string,
      name_en: string,
    }[],
    music_performance_roles: {
      id: number,
      role_text: string,
      name: string,
      name_en: string,
    }[],
  },
}) {
  return (
    <ul className="song_details">
      {music.music_production_and_engineering_roles.map((musicProductionAndEngineeringRole) => (
        <li key={musicProductionAndEngineeringRole.id}>
          <span>{musicProductionAndEngineeringRole.role_text}：</span>
          {musicProductionAndEngineeringRole.name}
          /
          {musicProductionAndEngineeringRole.name_en}
        </li>
      ))}
      {music.music_performance_roles.map((musicPerformanceRole) => (
        <li key={musicPerformanceRole.id}>
          <span>{musicPerformanceRole.role_text}：</span>
          {musicPerformanceRole.name}
          /
          {musicPerformanceRole.name_en}
        </li>
      ))}
      {music.remixer_name !== null && (
        <li>
          <span>リミキサー：</span>
          {music.remixer_name}
          /
          {music.remixer_name_en}
        </li>
      )}
    </ul>
  );
}

